;(function () {
    const comps = document.querySelectorAll('.template--superposed');
    if (!comps.length) return;

    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        console.warn('GSAP ou ScrollTrigger est manquant');
        return;
    }

    comps.forEach((comp, index) => {
        ScrollTrigger.create({
            trigger: comp,
            start: 'top top',
            end: 'bottom top',
            pin: true,
            pinSpacing: false,
            id: `superpose-${index}`,
            markers: false,
        });
    });
})();
